import React, { useState, useRef } from 'react';

import Head from 'next/head';
import Axios from 'axios';
import getMetaTagData from '../../../src/common/services/getMetaTagData';

import JumbotronEvent from '../../../src/component/m/carousel/JumbotronEvent';
import EventMainList from '../../../src/component/m/event/EventMainList';

function Event({ eventData, metaTagData, JWTTockenCheck }) {
  const jWTCheck = JWTTockenCheck; // 쓰일여지가있어서 살려둠
  const { top, bottom } = eventData; // TODO 데이터 테스트중
  const [relateContentIndex, setRelateContentIndex] = useState(0);
  const [relateContentIndexStatus, setRelateContentIndexStatus] = useState({
    index: 0,
    timeoutId: 0,
    changedTime: Date.now(),
  });
  const childRef = useRef(null);

  // 2depth 바꾸는 부분
  const onChangeMainTopFormationIndex = (index) => {
    const timeoutId = setTimeout(() => {
      setRelateContentIndexStatus((prev) => ({
        index,
        timeoutId: prev.timeoutId,
        changedTime: Date.now(),
      }));
    }, 200);

    setRelateContentIndexStatus((prev) => {
      // 0.5초 이내에 변경된 경우 슬라이딩 취소
      if (Date.now() - prev.changedTime < 200) {
        clearTimeout(timeoutId);
      }

      return { index: prev.index, timeoutId, changedTime: Date.now() };
    });
  };
  // 전체 스크롤 이벤트 잠시멈춤 제어 함수

  const mainContentsSubspotTouch = (e) => {
    childRef.current.contentsSubspotTouch(e);
  };

  return (
    <>
      <Head>
        <link
          rel="stylesheet"
          href={`${process.env.NEXT_PUBLIC_GLOBAL_CSS_M_URL}?v=${process.env.NEXT_PUBLIC_BUILD_TIME}`}
        />
        <meta
          name="viewport"
          content="user-scalable=no, initial-scale=1.0, maximum-scale=1.0, minimum-scale=1.0, width=device-width"
        />
        <script
          type="text/javascript"
          src={process.env.NEXT_PUBLIC_GNB_JS_URL}
        />

        <meta name="description" content={metaTagData.shareDescription} />
        <meta name="keywords" content={metaTagData.keywords} />
        <meta name="twitter:card" content="summary" />
        <noscript>Your browser does not support JavaScript!</noscript>
        <meta property="og:type" content="website" />
        <meta property="og:locale" content="ko_KR" />
        <meta property="og:site_name" content="SBS" />
        <meta property="og:title" content={metaTagData.shareTitle || ''} />
        <meta
          property="og:description"
          content={metaTagData.shareDescription || ''}
        />
        <meta property="og:image" content={metaTagData.shareImageUrl || ''} />
        <meta property="og:url" content={metaTagData.currentUrl || ''} />
        <meta name="nate:site_name" content="SBS" />
        <meta name="nate:title" content={metaTagData.shareTitle || ''} />
        <meta
          name="nate:description"
          content={metaTagData.shareDescription || ''}
        />
        <meta name="nate:image" content={metaTagData.shareImageUrl || ''} />
        <meta name="nate:url" content={metaTagData.currentUrl || ''} />
        <title>{metaTagData.shareTitle}</title>
      </Head>

      <div className="contents">
        {/* 페이지 명 클래스 */}
        <div className="event_listcontents_wrap">
          <h2 className="hide">event</h2>
          {/* 이벤트 섹션 top 영역 시작 : 상단 스와이프 모듈 */}
          {/* <div className='event_topswipe_w'> */}
          {/* api 데이터 나올시 아래꺼로 할것 */}
          {Array.isArray(top) && top.length > 0 && (
            <JumbotronEvent
              data={top}
              props={{ type: 'eventtopbox' }}
              onChangeCurrentIndex={onChangeMainTopFormationIndex}
              ref={childRef}
            />
          )}

          {Array.isArray(bottom) && bottom.length > 0 && (
            <EventMainList data={bottom} />
          )}
        </div>
      </div>
    </>
  );
}

// api 호출하는 부분
export async function getServerSideProps(ctx) {
  // header에서 meta teg에 넣어줄 데이터를 가져 오기 위함
  const { pageSection, pageCategory } = ctx.query;
  const { cookies } = ctx.req;
  const { LOGIN_JWT } = cookies;
  let metaTagData;
  let eventData;
  let JWTTockenCheck;

  try {
    if (LOGIN_JWT != null) {
      JWTTockenCheck = true;
    } else {
      JWTTockenCheck = false;
    }
    metaTagData = getMetaTagData(ctx.req.url, pageSection, pageCategory); // 메타 데이터 불러오는 부분(각페이지마다 있어야함) import 된 부분에서 호출됨
    eventData = await eventDataList();
  } catch (error) {
    console.error(error);
  }

  return { props: { eventData, metaTagData, JWTTockenCheck } };
}

const eventDataList = async () => {
  try {
    const liveEventList = await Axios.get(
      process.env.NEXT_PUBLIC_API_EVENT_LIST,
      { timeout: 3000 }
    );
    const eventData = liveEventList.data;
    return eventData;
  } catch (e) {
    console.error(e);
  }
};

export default Event;
